module.exports = __webpack_public_path__ + "img/businessModelRed1.4ae7349b.jpg";